<template>
	 <div class="dynamiclist qualityenterprise"> 
			<leftnav class="fl" mkcode="P" :itemcode="cur_list.itemcode" docutitle="看投资趋势"></leftnav> 
			<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''"> 
				<govheader></govheader>
				<div class="index_left_centerpage">
					<div class="whitebox right_topbox has-title-font" style="padding-bottom: 1px;">
						<div class="right_boxtitle map_title_tab ">
							<span class="title" :class="{current:page_id !=5}" @click="routerself('/invest-project-trend?type=3')">资本流入动态监测</span> 
							<span class="title" :class="{current:page_id == 5}" @click="routerself('/invest-project-trend?type=5')">资本流出动态监测</span> 
							<!-- <p class="fl titlefont" v-show="land_invest_type == 'invest'">上市公司虽然只是企业群体的一部分，但却是行业龙头企业的代表；<br>把握了上市公司的动态和趋势，就是把握了行业龙头企业的投资趋势。</p>
							<p class="fl titlefont" v-show="land_invest_type == 'land'">拿地投资项目的信息源，是地方政府国土部门发布的土地招拍挂公告，全国所有土地实时监测;<br>重点制造业投资项目几乎都涉及拿地，通过企业拿地投资数据，可以分析全国制造业的投资趋势。</p> -->
						
						</div> 
					<div class="opport-screen-list1"> 
						<dl class="opport-screen bdbe" v-if="page_id !=5">
							<dt class="fl">投资类型</dt>
							<dd class="fl"> 
								<span :class="page_id == list.id?'a-screen current':'a-screen'"  v-show="list.id!=5"
								v-for="(list,i) in page_list" :key="i" 	
								@click="routerself('/invest-project-trend?type='+list.id)">{{list.title}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe">
							<dt class="fl">投资项目</dt>
							<dd class="fl"> 
								<span :class="sourceCityId == list.value?'a-screen current':'a-screen'" 
								v-show="list.value!=userdata.currentCity.id"
								v-for="(list,i) in cur_list.children" :key="i" 	
								@click="toggleInvestLandType(list)">{{list.label}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="land_invest_type == 'invest'">
							<dt class="fl">投资模式</dt>
							<dd class="fl">
								<span :class="invest_pattern_id == 0?'a-screen current':'a-screen'" 	@click="invest_pattern_id=0;getdynamiclist()">全部</span>
								<span :class="invest_pattern_id == list.paraValue?'a-screen current':'a-screen'" v-for="(list,i) in investPattern" :key="i" 	
								@click="invest_pattern_id=list.paraValue;getdynamiclist()">{{list.paraName}}</span>
							</dd>
						</dl>
					 <dl class="opport-screen bdbe" v-show="land_invest_type == 'land'">
					 	<dt class="fl">土地性质</dt>
					 	<dd class="fl">
					 		<span :class="land_pattern_id == ''?'a-screen current':'a-screen'"
					 			@click="land_pattern_id='';getdynamiclist()">全部</span>
					 		<span :class="land_pattern_id == list.value?'a-screen current':'a-screen'"
					 			v-for="(list,index) in landPattern" :key="index"
					 			@click="land_pattern_id=list.value;getdynamiclist()">{{list.name}} </span> 
					 	</dd>
					 </dl>
						<projectIndustry :type="land_invest_type" @getIndustryId="getIndustryId" :refreshNum="refreshNum" :token="userdata.token"></projectIndustry> 
					</div>
				</div>
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" >产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p> 
					</div>
					<!-- 投资项目表格 -->
					<div class="enterprise_list_box" v-show="land_invest_type == 'invest'">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>公司名称</th>
								<th>项目名称</th>
								<th>投资来源地</th>
								<th>行业</th> 
								<th>投资地点</th>
								<th :key="i" v-for="(list,i) in dimesmlist" >
									{{list.name}} 
									</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterprise_list">
								<td>{{(page-1)*pageSize+i+1}}</td>
								<td>
									<span class="fwb curp" v-if="list.stockCode!=''"  @click="routerlinkid('/enterprises',list.stockCode)">{{list.shortName}}</span>
									<span v-if="list.stockCode==''">{{list.shortName}}</span> 
								</td>
								<td style="width:200px;"><span :class="(list.url && list.url!='' )? 'curp':''" @click="openProjectLink(list.url)">{{list.projectName}}</span></td>
								<td>{{list.sourceArea}}</td>
								<td>{{list.industry}}</td>
								<!-- <td>{{list.notion}}</td> -->
								<td>{{list.investArea}}</td>
								<td>{{list.money}}{{list.moneyUnit}}</td>
								<td>{{list.time}}</td> 
							</tr>  
						</table>
						<p class="orangefont w95mg mt-5 pl-10 fz20 boxs-bdb">
							本列表的数据时限为：2021年-2024年；要查看2017年到现在的全部数据，请访问 
							<span class="curp" @click="openProjectLink(listUrl)">上市公司投资项目库 ></span>
							</p>
					</div> 
					<!-- 拿地项目表格 -->
					<div class="enterprise_list_box" v-show="land_invest_type == 'land'">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>行政区</th>
								<th>项目名称</th>
								<th> 总面积(亩)</th>
								<th>土地用途</th>
								<th style="line-height: 20px;padding:10px 0; ">土地使用权人<br />(项目公司)</th>
								<th>投资主体</th>
								<th>投资来源地</th>
								<th>日期</th>
							</tr>
							<tr :key="index" v-for="(list,index) in enterprise_list">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td>{{list.area}}</td>
								<td style="width: 120px;"><span :class="(list.url && list.url!='' )? 'curp':''" @click="openProjectLink(list.url)">{{list.projectName}}</span></td>
								<td>{{list.size}}{{list.sizeUnit}}</td>
								<td>{{list.purpose}}</td>
								<td style="width: 110px;">
									<span class="curp" v-if="list.stockCode!=''"
										@click="routerlinkid('/enterprises',list.stockCode)">{{list.owner}}</span>
									<span v-if="list.stockCode==''">{{list.owner}}</span>
								</td>
								<td style="width: 110px;">
									<span class="curp" v-if="list.sourceStockCode!=''"
										@click="routerlinkid('/enterprises',list.sourceStockCode)">{{list.sourceEnterprise}}</span>
									<span v-if="list.sourceStockCode==''">{{list.sourceEnterprise}}</span>
								</td>
								<td>{{list.sourceArea}}</td>
								<td>{{list.time}}</td>
							</tr>
						</table>
						<p class="orangefont w95mg mt-5 pl-10 fz20 boxs-bdb">本列表的数据时限为：2021年-2024年；要查看2010年到现在的全部数据，请访问
						<span class="curp" @click="openProjectLink(listUrl)">全国企业拿地数据库 >
						</span>
						</p>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="getdynamiclist"></zpagenav>
					</div>
				</div> 
			</div>
		</div>
	</div>
</template>

<script>
	import projectIndustry from "@/components/inc/project-industry-list.vue"
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'invest-project-trend',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data: function(){
			return{
				userdata:{},
				listUrl:"",//列表跳转链接
				curWebsite:this.$api.getWebsiteType(),  	
				title: '上市公司在本市投资项目',	    
				dimesmlist:[{name: '投资金额',type: 1}, {	name: '日期',type: 2},],
				industrycode1:"",
				industrycode2:'',
				industryid:0,      
				enterprise_list:[], 
				order_field:0,
				order_type:1,  
				sourceType:"sourceCity",
				sourceCityId:0, 
				page_id:1,
				land_invest_type:'invest',
				ajaxurlData:{invest:"",land:""},
				ajaxurl:'', 
				page_list:[
				{id:3,
				type:'city',
				title:"企业在本市拿地投资项目",
				itemcode:"P-QYZBCNDTZ",
				ajax_type:'land',
				children:[
					{label:"本市全部已投项目",value:0,sourceType:"sourceCity",type:'land'},{label:"外地企业在本市已投项目",value:997,sourceType:"sourceProvince",type:'land'},
				]},
				{id:1,	
				type:'city',
				title:"上市公司在本市投资项目",
				itemcode:"P-SSGSZBCTZ",
				ajax_type:'invest',
				children:[
					{label:"本市全部已投项目",value:0,sourceType:"sourceCity",type:'invest'},{label:"外地企业在本市已投项目",value:997,sourceType:"sourceProvince",type:'invest'},
				]},
				{id:4,
				type:'province',
				title:"企业在本省拿地投资项目",
				itemcode:"P-QYZBSNDTZ",
				ajax_type:'land',
				children:[	
					{label:"省外企业在本省拿地投资项目",value:998,sourceType:'sourceProvince',type:'land'},
					{label:"北京企业在本省拿地投资项目",value:11,sourceType:'sourceProvince',type:'land'},
					{label:"上海企业在本省拿地投资项目",value:31,sourceType:'sourceProvince',type:'land'},
					{label:"深圳企业在本省拿地投资项目",value:4403,sourceType:'sourceCity',type:'land'}]},
				{id:2,	
				type:'province',
				title:"上市公司在本省投资项目",
				ajax_type:'invest',
				itemcode:"P-SSGSZBSTZ",
				children:[	
					{label:"省外上市公司在本省投资项目",value:998,sourceType:'sourceProvince',type:'invest'},
					{label:"北京上市公司在本省投资项目",value:11,sourceType:'sourceProvince',type:'invest'},
					{label:"上海上市公司在本省投资项目",value:31,sourceType:'sourceProvince',type:'invest'},
					{label:"深圳上市公司在本省投资项目",value:4403,sourceType:'sourceCity',type:'invest'}]},
				
				
				{id:5,	
				type:'city',
				title:"本市企业在外地投资项目",
				itemcode:"P-BSQYZWDTZ",
				ajax_type:'land',
				children:[{label:"本市企业在外地拿地项目",value:0,sourceType:"sourceCity",type:'land'},{label:"本市上市公司在外地投资项目",value:1,sourceType:"sourceCity",type:'invest'}]}, 
				
				],
				cur_list:{id:1,children:[],},
				category_list:[{label:"本市全部已投项目",value:0,sourceType:"sourceCity",listurl:""},{label:"外地企业在本市已投项目",value:997,sourceType:"sourceProvince",listurl:""}],
				investPattern: [], 
				invest_pattern_id:0,
				landPattern: [],
				land_pattern_id:0,
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				refreshNum:1,//切换路由时增加数字
			};
		},
		components:{
			projectIndustry
		},
		watch: {
			$route: function(newVal, oldVal) {   
				this.page_id = this.$route.query.type ? this.$route.query.type : 1;
				this.getCurPageList(this.page_id);
			}
		},
		created() { 
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
				this.userdata = this.getuseriformation();    
				this.ajaxurlData.land=this.$api.enterpriseapi.land.list();
				this.ajaxurlData.invest=this.$api.investapi.investdynamic.list();
			 
		},
	 
		mounted() {
		if(this.userdata.edition<1){
			var that=this;
				alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function(){
				that.routerself('/totalEnterprises');
			},1000)
			return;
		} 
		// this.category_list[0].value=this.userdata.city;
		// this.sourceCityId=this.userdata.city;
		this.page_id = this.$route.query.type ? this.$route.query.type : 1;
		this.getCurPageList(this.page_id);
		this.getinvestPattern();
		this.getlandPattern();
		},
		methods:{
			//本市本省外市等页面切换
			getCurPageList(id){
				this.bus.$emit('loading', true);
				var arry=this.page_list.filter(list=>{
					return list.id==id;
				})
				this.cur_list=arry[0];
				this.page=1;
				this.industryid=0;
				this.industrycode1=0;
				this.industrycode2=0;
				this.refreshNum++;
				this.invest_pattern_id=0;
				this.land_pattern_id=0;
				this.order_field=0; 
				this.land_invest_type=this.cur_list.ajax_type; 
				this.ajaxurl=this.ajaxurlData[this.cur_list.ajax_type];
				this.sourceType= this.cur_list.type == 'province'?"sourceProvince":'sourceCity';
				this.sourceCityId=this.cur_list.type == 'province' ? 998 : 0;
				this.getdynamiclist(); 
			},
			//切换页面内容
			toggleInvestLandType(list){
				this.sourceCityId=list.value;
				this.sourceType=list.sourceType; 
				this.land_invest_type=list.type;
				this.ajaxurl=this.ajaxurlData[list.type];
				this.getdynamiclist(); 
			},
			//跳转外投资项目库
			getInvestUrl(){ 
				var that=this;
					this.$axios.get(this.$api.enterpriseapi.land.url() ,{
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) { 
					// that.category_list[0].listurl=res.data.data.invest; 
					// that.listUrl=res.data.data.invest; 
				})
			},
			//投资动态跳转到投资项目库页面
			openProjectLink(url){
				if(url && url!= ''){
						window.open(url); //研究报告库外部跳转
				} 
			},
			//获取投资模式
			getinvestPattern() {
				var that = this, ajaxurl = '';
				ajaxurl = this.$api.investapi.parameter.list() + '?categoryId=4';
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log("投资模式", res, ajaxurl);
					if (res.data.success) {
						that.investPattern = res.data.list;
					} else {
						that.tokenfailed(res.data.msg);
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//获取土地性质筛选项
			getlandPattern() {
				var that = this;
				var ajaxurl = this.$api.enterpriseapi.parameter.landtype();
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log("拿地类型", res, ajaxurl);
					if (res.data.success) {
						that.landPattern = res.data.list;
					} else {
						that.tokenfailed(res.data.msg);
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
		 //点击热点行业后
			getIndustryId(id,code1,code2){
				this.industryid=id;
				this.industrycode1=code1;
				this.industrycode2=code2;
				this.getdynamiclist();
			} , 
		//获取动态列表
		getdynamiclist(page){ 
			// console.log(page,this.userdata.groupType);
			if(page && page>2 && this.userdata.groupType == 0){
				this.$message({type:"warning",message:"试用权限已用完，正式版可浏览全部内容"}); 
			}else{ 
			this.bus.$emit('loading', true);
			this.page=page?page:1;
		 var that=this;
			this.order_type=this.land_invest_type == 'invest'?0: 1; 
			var industryja1 =this.splicing('industry1',this.industrycode1);
			var industryja2 =this.splicing('industry2',this.industrycode2); 
			var investMode = this.land_invest_type == 'invest'? this.splicing('investMode', this.invest_pattern_id) : ''; 
			var landtype = this.land_invest_type == 'land'?this.splicing('landType', this.land_pattern_id) : ''; 
			var orderFieldJa=this.splicing('orderField',this.order_field);
			var orderTypeJa=this.splicing('orderType',this.order_type) ; 
			var sourceCityJa=this.splicing(this.sourceType,this.sourceCityId) ;
			var userCityja=this.splicing(this.cur_list.type,this.userdata[this.cur_list.type]); 
			var sourceExcludeja=this.page_id == 5 ? '&sourceExclude=2':''; 
			if(this.page_id == 5){
				var soucetype=this.userdata.currentCity.type == 'city' ? this.sourceType : 'province';
				sourceCityJa="&"+soucetype+"="+this.userdata.currentCity.id;
				userCityja="";
			}
			var ajaxurl=this.ajaxurl+'?pageSize=10&page='+this.page+orderFieldJa+orderTypeJa+ industryja1+industryja2+
			investMode+landtype+userCityja+sourceCityJa+sourceExcludeja+'&ver=1'; 
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function(res) { 
				console.log('获取动态列表',ajaxurl,res.data)
				if (res.data.success) {
					that.enterprise_list=res.data.list;  
					that.listUrl=res.data.extend.listUrl; 
					that.bus.$emit('loading', false);
					that.totalPage = res.data.totalPage; 
					that.total = res.data.totalRecord;
				} 
			}).catch(function(error) {
				// 请求失败处理 console.log(error);
			});
		}
		},
		//搜索关键词
		searchkwfun() {
			this.searchtext = $.trim(this.searchtext);
			// if(this.searchtext!="" || ){
			this.getdynamiclist();
			// } 
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		pageHandler: function(page) {
			this.page = page;
			this.getdynamiclist(page);
		}, 
		}
	}
</script>

<style>
	.a-red{
		color:#c00;
	}
	.right_boxtitle .el-tooltip{
		position: relative;top: 10px;
	}
</style>